<template v-if="store && store.isProfileNavigable === true && store.truRating && store.truRating.length > 0 && store.ratingCount && store.ratingCount > 0">
  <div
    id="map-popover"
    :class="[
      'absolute w-full max-h-max pb-3 px-3',
      isDesktop
        ? 'md:left-1/2 md:top-auto md:bottom-auto md:translate-x-[-50%] md:min-w-[320px] md:max-w-[480px]'
        : 'bottom-0 left-1/2 -translate-x-1/2 min-w-[250px] max-w-sm'
    ]"
  >
    <!-- Triangle pointer for desktop -->
    <div
      v-if="isDesktop"
      class="absolute -top-2 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-b-[10px] border-b-white z-50"
    ></div>

    <UCard
      v-if="store"
      :ui="{
        strategy: 'override',
        base: 'border shadow-lg',
        ring: '',
        divide: '',
        header: {
          padding: 'p-4 sm:p-4'
        },
        body: {
          padding: 'px-4 py-0 sm:px-4 pb-4 sm:py-0 sm:pb-4'
        },
        footer: {
          base: 'border-t-2 border-trublue-700',
          padding: 'py-4 px-4 sm:px-4'
        }
      }"
    >
      <template #header>
        <div class="flex justify-between">
          <h3 class="font-bold md:text-lg">
            {{ store.displayName }}
          </h3>
          <UButton
            variant="ghost"
            class="text-gray-600"
            :title="`Close popover for ${store.displayName}`"
            @click="closePopover()"
          >
            <font-awesome-icon icon="fa-solid fa-x" />
          </UButton>
        </div>
        <h4 class="mt-2 text-sm font-semibold">
          {{ addressConcatenated }}
        </h4>
      </template>
      <div class="flex justify-between">
        <div class="flex items-center space-x-2 text-xs text-gray-600">
          <span v-for="badgeText in store.badges" :key="badgeText">{{ badgeText }}</span>
        </div>
        <div class="flex items-center justify-end w-24 text-sm font-semibold shrink-0 text-purple">
          <img src="@/assets/images/map-pin.svg" alt="Map Pin" class="w-5 h-5 mr-2" />
          <span>{{ distanceUtil.formatDistance(store.distance) }}</span>
        </div>
      </div>
      <template #footer>
        <div class="flex gap-x-2">
          <img
            src="@/assets/images/trubutton.svg"
            alt="trubutton"
            width="56"
            height="56"
            class="relative self-start w-12 h-12 md:w-14 md:h-14 -top-1"
          />
          <div class="flex flex-wrap items-center justify-between w-full">
            <UiStarRatings
              v-if="store.truRating && store.ratingCount"
              :rating="parseFloat(store.truRating)"
              :total-ratings="store.ratingCount"
              :size="isDesktop ? 'regular' : 'small'"
            />
            <span v-else>{{ t('noRatingsAvailable') }}</span>
            <UButton
              v-if="store.isProfileEnabled"
              :to="store.profileUrl"
              target="_blank"
              variant="outline"
              size="xs"
              :ui="{
                rounded: 'rounded-2xl',
                font: 'font-bold'
              }"
              class="mt-4 text-trublue-700"
            >
              {{ t('more') }}
              <template #trailing>
                <font-awesome-icon icon="fa-solid fa-chevron-right" class="text-trublue-700" />
              </template>
            </UButton>
          </div>
        </div>
      </template>
    </UCard>
  </div>
</template>

<script setup lang="ts">
import type { StoreResult } from '@/types'

const { t } = useI18n()
const props = defineProps<{ store: StoreResult | undefined }>()
const emit = defineEmits<{ close: [] }>()
const { isMobile, isDesktop } = useDevice()
const ui = useUiStore()
const distanceUtil = useDistanceStore()

function closePopover() {
  if(!isMobile) {
    ui.showListView()
  }
  emit('close')
}

let addressConcatenated = ''
if (props.store) {
  const { town, county, postCode } = props.store
  addressConcatenated = [town, county, postCode].filter(Boolean).join(', ')
}
</script>
